/**
 * Lets non-React code ask for the sign-in popup.
 *
 * `api/client.ts` detects an expired session inside a fetch wrapper, far from any
 * component, so it cannot call a hook. It used to resolve that with
 * `window.location.href = '/login'` — a full page reload onto the login page,
 * which threw away whatever the user was doing. It now emits here and
 * `AuthModalProvider`, which is subscribed, clears the session and opens the popup.
 *
 * Deliberately a single listener rather than a list: exactly one provider is
 * mounted, and a stale second subscriber would double-fire the sign-out.
 */

type Listener = () => void

let listener: Listener | null = null

/** Subscribe the (single) provider. Returns an unsubscribe for cleanup. */
export function onAuthModalRequest(fn: Listener): () => void {
  listener = fn
  return () => {
    if (listener === fn) listener = null
  }
}

/** Ask for the sign-in popup from outside React. No-op if nothing is mounted. */
export function requestAuthModal(): void {
  listener?.()
}
